import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-penetration80100-page',
  templateUrl: './penetration80100-page.component.html',
  styleUrls: ['./penetration80100-page.component.scss']
})
export class Penetration80100PageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
